import nodeClient from "./node-client";

export const searchManufacturer = async (query) => {
  const response = await nodeClient(
    `/service/private/v0/search/manufacturer?${encodeURI(query)}`
  );
  return response.data;
};
